import { send } from 'server';
export const EXPAND_ITEM = 'EXPAND_ITEM';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const SET_ERROR = 'SET_ERROR';

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    payload: isLoading
});

export const setError = ({ error }) => ({
    type: SET_ERROR,
    payload: { error }
});

export const getBonuses = (fromDate, toDate) => send({
    ID: 31085,
    description: 'Get bonuses (pick pre-wagers)',
    responses: [31086, 31087],
    limit: 450,
    statusFilter: 1,
    issuedAfterDate: window.Playtech.API.formatter.getDateForIms(fromDate),
    issuedBeforeDate: window.Playtech.API.formatter.getDateForIms(toDate),
    returnBonusTemplateDetails: true,
    returnBonusStats: false,
    returnGamingContexts: true,
    returnGameWeightsConfigurations: false,
    returnWageringCoefficients: false
});

export const expandItemAction = index => ({
    type: EXPAND_ITEM,
    payload: index
});
